<template>
  <div>
    <v-app>
      <resizable-page>
        <template v-slot:table="tableProps">
          <v-card>
            <!-- <v-card-title>
     Procurement Order List
    </v-card-title> -->
            <v-card-title>
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="ma-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Export To XLS
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item link>
                    <downloadExcel
                      class="btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExportBefore('all');
                        }
                      "
                    >
                      All Record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item link>
                    <downloadExcel
                      class="btn"
                      :data="exportDisplayedPage"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                    >
                      Displayed record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item link>
                    <downloadExcel
                      class="btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExportBefore('filter');
                        }
                      "
                    >
                      All filtered record
                    </downloadExcel>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-spacer></v-spacer>
              <div class="d-flex flex-wrap">
                <!-- filter date -->
                <div class="shadow d-flex">
                  <div class="mt-5 mx-5">
                    <input
                      type="date"
                      class="form-control"
                      placeholder="Username"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <p class="mt-5 fs-small">s/d</p>
                  <div class="mt-5 mx-5">
                    <input
                      type="date"
                      class="form-control"
                      placeholder="Username"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <v-btn :disabled="!search" class="mt-5" small color="primary">
                    <v-icon>mdi-calendar-filter</v-icon>
                  </v-btn>
                </div>
                <v-select
                  style=" max-width: 150px;"
                  :items="option_filter"
                  label="Select"
                  v-model="searchCategory"
                  @change="search = ''"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
                <v-text-field
                  :disabled="!searchCategory"
                  v-model="search"
                  label="Search"
                  class="ma-2"
                  single-line
                  hide-details
                >
                </v-text-field>
                <v-btn
                  :disabled="!search"
                  class="mt-5"
                  small
                  color="primary"
                  @click="searchButton"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn
                  v-if="searchValue"
                  class="mt-5 ml-1"
                  dark
                  small
                  color="red"
                  @click="clearSearchButton"
                  >Clear</v-btn
                >
              </div>
            </v-card-title>
            <!-- <v-data-table
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100, -1]}"
      :options="{'itemsPerPage':50}"
    > -->
            <v-data-table
              mobile-breakpoint
              :headers="headers"
              :items="table"
              :loading="loadTable"
              loading-text="Loading... Please wait"
              @current-items="getFiltered"
              ref="vTable"
              :height="tableProps.tableHeight"
              fixed-header
              :options.sync="options"
              :server-items-length="totalDataTable"
              :page="page"
              :pageCount="numberOfPages"
              single-expand
              show-expand
              :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
            >
              <template v-slot:[`header.driver_dp_status`]="{ header }">
                <v-select
                  style=" font-size:10px;"
                  :items="optionStatus"
                  :label="header.text"
                  v-model="valueStatus"
                  @change="getList"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
              </template>
              <template v-slot:[`item.last_payment_history`]="{ item }">
                <span v-if="item.payment_history != 0">{{
                  item.payment_history[0].payment_at
                }}</span>
              </template>
              <template v-slot:[`item.kip_no`]="{ item }">
                <span v-if="item.driver_dp_driver">{{
                  item.driver_dp_driver.driver_no
                }}</span>
              </template>
              <template v-slot:[`item.driver_name`]="{ item }">
                <span v-if="item.driver_dp_driver">{{
                  item.driver_dp_driver.driver_name
                }}</span>
              </template>
              <template v-slot:[`item.dp_amount`]="{ item }">
                <span style="float:left;">Rp.</span>
                <span style="float:right;">{{
                  formatPrice(item.driver_dp.dp_amount)
                }}</span>
              </template>
              <template v-slot:[`item.payment_amount`]="{ item }">
                <span style="float:left;">Rp.</span>
                <span style="float:right;">{{
                  formatPrice(item.payment_amount)
                }}</span>
              </template>
              <template v-slot:[`item.driver_dp_status`]="{ item }">
                <span v-if="item.driver_dp_status == 0">Unpaid</span>
                <span v-else-if="item.driver_dp_status == 1">Partial Paid</span>
                <span v-else-if="item.driver_dp_status == 2">Paid</span>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td class="pa-5" :colspan="headers.length">
                  Payment History - Paid:
                  <md-table class="ma-5">
                    <md-table-row>
                      <md-table-head><b>Payment Date</b></md-table-head>
                      <md-table-head><b>Payment Method</b></md-table-head>
                      <md-table-head><b>Amount</b></md-table-head>
                    </md-table-row>
                    <md-table-row
                      v-for="(item, index) in item.payment_history"
                      :key="index"
                    >
                      <md-table-cell>{{ item.payment_at }}</md-table-cell>
                      <md-table-cell>
                        <span v-if="item.payment_method == 1">Cash</span>
                        <span v-if="item.payment_method == 2">Transfer</span>
                        <span v-if="item.payment_method == 3">Debit</span>
                        <span v-if="item.payment_method == 4"
                          >Virtual Account</span
                        >
                      </md-table-cell>
                      <md-table-cell>
                        <span style="float:left;">Rp.</span>
                        <span style="float:right;">{{
                          formatPrice(item.payment_receive_amount)
                        }}</span>
                      </md-table-cell>
                    </md-table-row>
                    <md-table-row v-if="item.payment_history.length != 0">
                      <md-table-cell class="md-title"
                        >Total Paid Amount</md-table-cell
                      >
                      <md-table-cell></md-table-cell>
                      <md-table-cell class="md-title">
                        <span style="float:left;">Rp.</span>
                        <span style="float:right;">{{
                          formatPrice(item.payment_amount)
                        }}</span>
                      </md-table-cell>
                    </md-table-row>
                    <md-table-row v-else>
                      <md-table-cell
                        style="text-align: center;"
                        colspan="6"
                        class="nodata"
                        >Driver does not make any payment yet</md-table-cell
                      >
                    </md-table-row>
                  </md-table>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </template>
      </resizable-page>
    </v-app>
  </div>
</template>

<script>
import vuetify from "@/plugins/vuetify";
import JsonExcel from "vue-json-excel";
import { ResizablePage } from "@/components";

export default {
  components: {
    downloadExcel: JsonExcel,
    ResizablePage,
  },
  vuetify,
  data() {
    return {
      mounted: true,
      optionStatus: [
        { text: "All", value: "" },
        { text: "Paid", value: "2" },
        { text: "Partial Paid", value: "1" },
        { text: "Unpaid", value: "0" },
      ],
      valueStatus: "",
      searchValue: null,
      searchCategory: null,
      option_filter: [
        { text: "Dp No.", value: "dp_no" },
        { text: "KIP no.", value: "kip_no" },
        { text: "Driver Name", value: "driver_name" },
        { text: "DP Name", value: "dp_name" },
      ],
      page: 1,
      totalDataTable: 0,
      numberOfPages: 0,
      loadTable: false,
      role: "",
      search: "",
      options: {},
      headers: [
        { text: "", value: "data-table-expand" },
        { text: "Registration Fee no.", value: "driver_dp_doc_no" },
        { text: "KIP No.", value: "kip_no" },
        { text: "Driver Name", value: "driver_name" },
        { text: "DP Name", value: "driver_dp.dp_amount_name" },
        { text: "Amount", value: "dp_amount" },
        { text: "Paid Amount", value: "payment_amount", align: "center" },
        {
          text: "Last Payment Date",
          value: "last_payment_history",
          align: "center",
        },
        {
          text: "Status",
          value: "driver_dp_status",
          align: "center",
          sortable: false,
        },
      ],
      table: [],
      worksheetName: "Driver DP",
      fileName: "Driver DP.xls",
      exportDisplayedPage: [],
      exportAllFitered: [],
      exportAll: [],
      field_export: {
        no: "no",
        dp_no: "dp_no",
        kip_no: "kip_no",
        driver_name: "driver_name",
        dp_name: "dp_name",
        dp_amount: "dp_amount",
        paid_amount: "paid_amount",
        status: "status",
        created_at: "created_at",
        updated_at: "created_at",
        no_payment: "no_payment",
        payment_no: "payment_no",
        payment_method: "payment_method",
        payment_at: "payment_at",
        payment_receive_amount: "payment_receive_amount",
        created_at: "created_at",
        updated_at: "updated_at",
      },
    };
  },
  watch: {
    options: {
      handler() {
        if (!this.mounted) {
          this.getList();
        }
      },
    },
    deep: true,
  },
  async mounted() {
    //get list role dan permission current user
    this.role = await this.$store.getters["role_permission/route_filter"];
    this.getList();
    this.mounted = false;
  },
  methods: {
    // ambil data yang dibutuhkan

    async getList() {
      this.loadTable = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      console.log(this.options);
      let pageNumber = page;

      let itemsPerPageNumber = itemsPerPage;

      var query = { page: { number: pageNumber, size: itemsPerPageNumber } };

      if (sortBy.length != 0) {
        var sort = sortBy[0];
        if (sortDesc[0]) {
          sort = "-" + sortBy[0];
        }
        query.sort = sort;
      }

      if (this.searchValue && this.searchCategory) {
        if (query.filter) {
          Object.assign(query.filter, {
            [this.searchCategory]: this.searchValue,
          });
        } else {
          query.filter = { [this.searchCategory]: this.searchValue };
        }
      }

      if (this.valueStatus != "") {
        if (query.filter) {
          Object.assign(query.filter, { driver_dp_status: this.valueStatus });
        } else {
          query.filter = { driver_dp_status: this.valueStatus };
        }
      }

      await this.$store.dispatch("fms_driver_dp/list", query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
      this.table = await this.$store.getters["fms_driver_dp/list"];
      var pageMeta = await this.$store.getters[
        "fms_driver_dp/page"
      ];
      // }
      // else{
      //   this.table = []
      // }
      console.log(pageMeta);
      this.totalDataTable = pageMeta.total;
      this.numberOfPages = pageMeta["to"];
      this.loadTable = false;
    },

    formatPrice(value) {
      let val = (value / 1).toFixed().replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    searchButton() {
      this.searchValue = this.search;
      this.getList();
    },
    clearSearchButton() {
      this.searchValue = null;
      this.search = null;
      this.searchCategory = null;
      this.getList();
    },

    getFiltered(data) {
      this.exportDisplayedPage = this.dataExport(data);
      // if(this.$refs.vTable){
      //   this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
      // }
      // else{
      //   this.exportAllFitered = this.dataExport(this.table)
      // }
    },

    async dataExportBefore(type) {
      if (this.table.length != 0) {
        if (type == "all") {
          await this.$store.dispatch("fms_driver_dp/list");
          return this.dataExport(
            await this.$store.getters["fms_driver_dp/list"]
          );
        } else if (type == "filter") {
          var query = {};

          if (this.searchValue && this.searchCategory) {
            query.filter = { [this.searchCategory]: this.searchValue };
          }

          if (this.valueStatus != "") {
            if (query.filter) {
              Object.assign(query.filter, {
                driver_dp_status: this.valueStatus,
              });
            } else {
              query.filter = { driver_dp_status: this.valueStatus };
            }
          }

          await this.$store.dispatch("fms_driver_dp/list", query);
          return this.dataExport(
            await this.$store.getters["fms_driver_dp/list"]
          );
        }
      }
    },

    dataExport(data) {
      var dataReturn = [];
      data.forEach((value, index) => {
        var status = "";
        if (value.driver_dp_status == 0) {
          status = "Unpaid";
        } else if (value.driver_dp_status == 1) {
          status = "Partial Paid";
        } else if (value.driver_dp_status == 2) {
          status = "Paid";
        }
        value.payment_history.forEach((value_1, index_1) => {
          var payment_method = "";
          if (value_1.payment_method == 1) {
            payment_method = "Cash";
          } else if (value_1.payment_method == 2) {
            payment_method = "Transfer";
          } else if (value_1.payment_method == 3) {
            payment_method = "Debit";
          } else if (value_1.payment_method == 4) {
            payment_method = "Virtual Account";
          }
          var data = {
            no:
              dataReturn[index] && dataReturn[index].no == index + 1
                ? null
                : index + 1,
            dp_no:
              dataReturn[index] && dataReturn[index].no == index + 1
                ? null
                : value.driver_dp_doc_no,
            kip_no:
              (dataReturn[index] && dataReturn[index].no == index + 1) ||
              !value.driver_dp_driver
                ? null
                : value.driver_dp_driver.driver_no,
            driver_name:
              (dataReturn[index] && dataReturn[index].no == index + 1) ||
              !value.driver_dp_driver
                ? null
                : value.driver_dp_driver.driver_name,
            dp_name:
              (dataReturn[index] && dataReturn[index].no == index + 1) ||
              !value.driver_dp_driver
                ? null
                : value.driver_dp.dp_amount_name,
            dp_amount:
              dataReturn[index] && dataReturn[index].no == index + 1
                ? null
                : value.driver_dp.dp_amount,
            paid_amount:
              dataReturn[index] && dataReturn[index].no == index + 1
                ? null
                : value.payment_amount,
            status:
              dataReturn[index] && dataReturn[index].no == index + 1
                ? null
                : status,
            created_at:
              dataReturn[index] && dataReturn[index].no == index + 1
                ? null
                : value.created_at,
            updated_at:
              dataReturn[index] && dataReturn[index].no == index + 1
                ? null
                : value.created_at,
            no_payment: index_1 + 1,
            payment_no: value_1.payment_no,
            payment_method: payment_method,
            payment_at: value_1.payment_at,
            payment_receive_amount: value_1.payment_receive_amount,
          };

          dataReturn.push(data);
        });
      });
      return dataReturn;
    },
  },
};
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
  font-size: 0.8rem;
}
</style>
